import { render, staticRenderFns } from "./OdontogramaNovoAtendimento.vue?vue&type=template&id=59a1fdb0&scoped=true"
import script from "./OdontogramaNovoAtendimento.vue?vue&type=script&lang=js"
export * from "./OdontogramaNovoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaNovoAtendimento.vue?vue&type=style&index=0&id=59a1fdb0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a1fdb0",
  null
  
)

export default component.exports